import { useCallback, useEffect } from 'react';
import { useSelector } from 'frontStaticAppPath/lib';

const AppStyles = () => import('src/styles/app-background.less');
/**
 * Для statportal используется отличный фон
 */
const useAppBackground = (): void => {
    const isProxiedComponent = useSelector(({ isProxiedComponent }) => isProxiedComponent);

    const loadStyles = useCallback(async () => {
        if (!isProxiedComponent) {
            await AppStyles();
        }
    }, [isProxiedComponent]);

    useEffect(() => void loadStyles(), [loadStyles]);
};

export default useAppBackground;
